import React, { useState, useEffect } from 'react';
import CustomTitle from '../../components/CustomTitle';
import { Flex, Space, Table, message, Typography } from 'antd';
import { AddItemButton, CustomParagraph } from '../../components';
import deleteIcon from '../../assets/images/delete.svg';
import editIcon from "../../assets/images/edit-icon.svg";
import { useNavigate } from 'react-router-dom';
import { useToken } from '../../common/helper';
import { useSpin } from '../../components/SpinContext';
import { GetProducts, DeleteProduct } from '../../api\'s/onboarding';
import { useSelector, useDispatch } from "react-redux";
import { fetchAllProducts,selectProductState  } from "../../reudx-toolkit/slice/ProductSlice.js";


const { Paragraph } = Typography;

const SettingsProduct = ({ title }) => {
    const [productsList, setProductsList] = useState([]);
    const navigate = useNavigate();
    const { token, removeToken } = useToken();
    const { showSpin, hideSpin } = useSpin();
    const state = useSelector(selectProductState);
  const dispatch = useDispatch();
  const [requestStatus,setRequestStatus] =useState(null);



    // const unauthorize = (error) => {
    //     if (error && error?.status === 401) {
    //         removeToken();
    //         navigate("/login");
    //     }
    // }

      useEffect(()=>{
          if(dispatch){
            dispatch(fetchAllProducts(token))
          }
        },[dispatch]);
      
        //setting data from store
        useEffect(()=>{
          if(state){
            setRequestStatus(state?.status ? state.status : null)
          if(state?.productList.length>0){
            setProductsList(state?.productList)
          }
        }
        },[state]);
    
         //if status is unauthorize
          useEffect(()=>{
            if(requestStatus){
              unauthorize(requestStatus);
            }
          },[requestStatus])
           
          const unauthorize = (status) => {
            if (status === 401) {
              removeToken();
              navigate("/login");
            }
          }

    //fetch all products
    // const fetchProducts = () => {
    //     showSpin();
    //     GetProducts(token)
    //         .then((res) => {
    //             const data = res?.data || null;
    //             if (data) {
    //                 if (data.data?.is_success) {
    //                     if (data.data.data && data.data.data.length > 0) {
    //                         setProductsList(data.data.data)
    //                     }
    //                 } else {
    //                     message.error(data?.data?.message);
    //                 }
    //             }
    //         })
    //         .catch((error) => {
    //             unauthorize(error);
    //         }).finally(() => {
    //             hideSpin();
    //         });

    // };

    // useEffect(() => {
    //     fetchProducts();
    // }, []);


    const columns = [
        {
            title: "Product name",
            dataIndex: "name",
            key: "name",
            width: 80,
            fixed: true,
            render: (text) => <CustomParagraph noText='-' text={text} fontSize={14} fontWeight={500} color="#000" marginBottom={0} />,
        },
        {
            title: "Product type",
            dataIndex: "product_name",
            key: "product_name",
            render: (text) => <CustomParagraph noText='-' text={text} fontSize={14} fontWeight={500} color="#000" marginBottom={0} />,
        },
        {
            title: "Stage of development",
            dataIndex: "stage_of_development",
            key: "stage_of_development",
            render: (text) => <CustomParagraph noText='-' text={text} fontSize={14} fontWeight={500} color="#000" marginBottom={0} />,
        },
        {
            title: "Commercial value",
            dataIndex: "commercial_value",
            key: "commercial_value",
            render: (text) => <CustomParagraph noText='-' text={text} fontSize={14} fontWeight={500} color="#000" marginBottom={0} />,
        },
        {
            title: "Project ID",
            dataIndex: "project_id",
            key: "project_id",
            render: (text) => <CustomParagraph noText='-' text={text} fontSize={14} fontWeight={500} color="#000" marginBottom={0} />,
        },
        {
            title: "Transit viability window",
            dataIndex: "viability_window",
            key: "viability_window",
            render: (text) => <CustomParagraph noText='-' text={text} fontSize={14} fontWeight={500} color="#000" marginBottom={0} />,
        },
        {
            title: "Temperature range",
            dataIndex: "temperature_range",
            key: "temperature_range",
            render: (_, record) => {
                const minTemp = record.temperature_min || "-";
                const maxTemp = record.temperature_max || "-";
                const range = record.temperature_range || "";
                return (
                    <Paragraph style={{ color: "#000", fontSize: "14px", fontWeight: "500", marginBottom: "0" }}>
                        {range!= "none" && (<div>{`${minTemp} to ${maxTemp}`}</div>)}
                        <div style={{ marginTop: "4px", color: "#5E5E5E", textTransform: "capitalize" }}>{`${range}`}</div>
                    </Paragraph>
                );
            }
        },
        {
            title: "",
            dataIndex: "action",
            key: "action",
            render: (text, record) => (
                <Flex gap={6}>
                    <Flex justify="center" align="center" style={{ width: "32px", height: "32px", cursor: "pointer" }}>
                        <img src={editIcon} alt='' onClick={() => handleEdit(record)} />
                    </Flex>

                    <Flex justify="center" align="center" style={{ width: "32px", height: "32px", cursor: "pointer" }}>
                        <img src={deleteIcon} alt='' onClick={() => handleDelete(record)} />
                    </Flex>
                </Flex>
            ),
        }
    ]

    //Table actions
    const handleDelete = (record) => {
        if(record && record.id){
            showSpin();
            DeleteProduct(record.id,token)
            .then((res) => {
                const data = res?.data || null;
                if (data) {
                    if (data.data?.is_success) {
                        message.success(data?.data?.message)
                       dispatch(fetchAllProducts(token))
                    } else {
                        message.error(data?.data?.message);
                    }
                }
            })
            .catch((error) => {
                unauthorize(error);
            }).finally(() => {
                hideSpin();
            });

        }
    };

    const handleEdit = (record) => {
        let userId = record?.id ? record.id : "";
        navigate(`/settings/product/form/${userId}`);
    };



    return (
        <>
            <CustomTitle text={title} fontSize={24} fontWeight="640" lineHeight="32px" color="#000" marginBottom={0} />
            <Space direction="vertical" size={16} style={{ width: "100%" }}>
                <Table  columns={columns} dataSource={productsList} pagination={false} className="custom-table" rowHoverable={false} />
                <AddItemButton text={"Create another"} onClick={() => { navigate('/settings/product/form'); }} />
            </Space>
        </>
    );
}

export default SettingsProduct;